import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SplitterLayout from 'react-splitter-layout';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import { Column } from 'devextreme-react/gantt';
import { DateBox, SelectBox, Template, TextBox } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import styles from './editact.module.scss';
import DataGridMVP from '../DataGridMVP';
import columnDataGridAct from './columnDataGridAct';
import { normalizeDateToSend } from '../../utils/functions';
import PopupMVP from '../PopupMVP';
import columnDataGridPiece from './columnDataGridPiece';

const docNumIdsDefault = [];
const initialModalState = {
  modalActDelete: false,
  modalActUpdate: false,
  modalAddPiece: false,
  modalDeletePiece: false
};

const EditAct = ({
  documentsReducer: {
    actDelete,
    actLoading,
    actsByStock,
    actsSign,
    actUpdate,
    addPiece,
    deletePiece,
    okUpdate,
    pieceLoading,
    piecesByAct,
    piecesByStock,
    visiblePopupSignSelected,
    selectedDocItems
  },
  tabsReducer: { tabSelect },
  addPieceToAct,
  addPieceToActClear,
  deleteAct,
  deleteActClear,
  deletePieceFromAct,
  deletePieceFromActClear,
  getActsByStock,
  getPiecesByAct,
  getPiecesByStock,
  plantId,
  signActsByClient,
  shippingType,
  updateAct,
  updateActClear,
  setInitialStateActs,
  modalErrorOpen,
  setVisiblePopupSignSelected
}) => {
  const selectedDocNumIds = selectedDocItems.map((el) => el.docNumId || el.mh3NumId);
  const selectedDocIds = selectedDocItems.map((el) => el.docId || el.mh3);

  const [dataSource, setDataSource] = useState({ selectList: [] });
  const [dataSourcePiece, setDataSourcePiece] = useState({ selectList: [] });

  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    filter: ''
  });
  const [filterDataGridPiece, setFilterDataGridPiece] = useState({
    filter: ''
  });

  const [modalsVisible, setModalsVisible] = useState(initialModalState);

  const [actData, setActData] = useState({
    docNumId: '',
    docId: '',
    docDate: '',
    docTypeNumId: null,
    docStatus: null
  });

  const [pieceData, setPieceData] = useState('');
  const [docNumIds, setDocNumIds] = useState(docNumIdsDefault);
  const [actsGridInstance, setActsGridInstance] = useState({});

  useEffect(() => {
    if ((tabSelect === 6 && plantId !== null) || okUpdate) {
      getActsByStock({
        plantId,
        filter: filterDataGrid.filter
      });
      setInitialStateActs();
    }
  }, [
    filterDataGrid.filter,
    getActsByStock,
    plantId,
    tabSelect,
    okUpdate,
    setInitialStateActs
  ]);

  useEffect(() => {
    if (tabSelect === 6 && dataSource.selectList.length && dataSource.selectList.length === 1) {
      getPiecesByAct({
        docNumId: dataSource.selectList[0].docNumId,
        filter: filterDataGridPiece.filter
      });
    }
  }, [filterDataGridPiece.filter, dataSource.selectList, getPiecesByAct, tabSelect]);

  useEffect(() => {
    if (tabSelect === 6 && modalsVisible.modalAddPiece) {
      getPiecesByStock({
        docType: actData.docTypeNumId,
        plantId
      });
    }
  }, [actData.docTypeNumId, getPiecesByStock, modalsVisible.modalAddPiece, plantId, tabSelect]);

  const onHidingModals = useCallback(() => {
    setModalsVisible(initialModalState);
  }, []);

  useEffect(() => {
    if (actUpdate.okRequest) {
      onHidingModals();
      updateActClear();
    }
  }, [
    actUpdate.okRequest,
    onHidingModals,
    updateActClear
  ]);

  useEffect(() => {
    if (actDelete.okRequest) {
      onHidingModals();
      deleteActClear();
    }
  }, [
    actDelete.okRequest,
    onHidingModals,
    deleteActClear
  ]);

  useEffect(() => {
    if (addPiece.okRequest) {
      onHidingModals();
      addPieceToActClear();
    }
  }, [
    addPiece.okRequest,
    onHidingModals,
    addPieceToActClear
  ]);

  useEffect(() => {
    if (deletePiece.okRequest) {
      onHidingModals();
      deletePieceFromActClear();
    }
  }, [
    deletePiece.okRequest,
    deletePieceFromActClear,
    onHidingModals
  ]);

  useEffect(() => {
    if (actsSign.okRequest) {
      notify(
        {
          message: formatMessage('actsSigned'),
          height: 64,
          width: 354,
          position: { at: 'top center', my: 'top center', offset: '0 48' }
        },
        'success',
        2000
      );
      getActsByStock({
        plantId,
        filter: filterDataGrid.filter
      });
      actsGridInstance.instance.clearSelection();
      setVisiblePopupSignSelected(false);
      setInitialStateActs();
    }
  }, [
    actsGridInstance.instance,
    actsSign.okRequest,
    filterDataGrid.filter,
    getActsByStock,
    onHidingModals,
    plantId,
    setInitialStateActs,
    setVisiblePopupSignSelected
  ]);

  const onSelectionChanged = useCallback(({ selectedRowsData }) => {
    if (selectedRowsData.length && selectedRowsData.length === 1) {
      setActData({
        docNumId: selectedRowsData[0].docNumId,
        docId: selectedRowsData[0].docId,
        docDate: selectedRowsData[0].docDate,
        docTypeNumId: selectedRowsData[0].docTypeNumId,
        docStatus: selectedRowsData[0].docStatus
      });
      setDocNumIds(docNumIdsDefault);
    } else if (selectedRowsData.length && selectedRowsData.length > 1) {
      setDocNumIds(selectedRowsData.map((item) => item.docNumId));
    }
    setDataSource({
      selectList: selectedRowsData
    });
  }, []);

  const onSelectionChangedPiece = useCallback(({ selectedRowsData }) => {
    setDataSourcePiece({
      selectList: selectedRowsData.map((item) => item.pieceNumId)
    });
  }, []);

  const openUpdateActModal = useCallback(() => {
    setModalsVisible({
      ...modalsVisible,
      modalActUpdate: true
    });
  }, [modalsVisible]);

  const openDeleteActModal = useCallback(() => {
    setModalsVisible({
      ...modalsVisible,
      modalActDelete: true
    });
  }, [modalsVisible]);

  const openUpdateAddPiece = useCallback(() => {
    setModalsVisible({
      ...modalsVisible,
      modalAddPiece: true
    });
  }, [modalsVisible]);

  const openUpdateDeletePiece = useCallback(() => {
    setModalsVisible({
      ...modalsVisible,
      modalDeletePiece: true
    });
  }, [modalsVisible]);

  const handleUpdateAct = useCallback(() => {
    if (actData.docId && actData.docDate) {
      updateAct({
        docNumId: actData.docNumId,
        docId: actData.docId,
        docDate: actData.docDate,
        plantId,
        filter: filterDataGrid.filter
      });
    }
  }, [
    actData,
    plantId,
    updateAct,
    filterDataGrid.filter
  ]);

  const handleDeleteAct = useCallback(() => {
    if (actData.docId && actData.docDate) {
      deleteAct({
        plantId,
        docNumId: actData.docNumId,
        filter: filterDataGrid.filter
      });
    }
  }, [
    actData,
    plantId,
    deleteAct,
    filterDataGrid.filter
  ]);

  const handleAddPiece = useCallback(() => {
    if (pieceData) {
      addPieceToAct({
        pieceNumId: pieceData,
        filter: filterDataGridPiece.filter,
        docNumId: actData.docNumId
      });
    }
  }, [
    pieceData,
    addPieceToAct,
    actData,
    filterDataGridPiece.filter
  ]);

  const handleDeletePiece = useCallback(() => {
    if (dataSourcePiece.selectList.length) {
      deletePieceFromAct({
        pieceNumIds: dataSourcePiece.selectList,
        docNumId: actData.docNumId,
        filter: filterDataGrid.filter
      });
    }
  }, [
    dataSourcePiece.selectList,
    deletePieceFromAct,
    actData,
    filterDataGrid.filter
  ]);

  const onSignPopupHiding = useCallback(() => {
    actsGridInstance.instance.clearSelection();
    setVisiblePopupSignSelected(false);
  }, [actsGridInstance.instance, setVisiblePopupSignSelected]);

  const onSignConfirmClick = useCallback(() => {
    signActsByClient(docNumIds.length ? docNumIds : selectedDocNumIds);
    setVisiblePopupSignSelected(false);
  }, [docNumIds, selectedDocNumIds, setVisiblePopupSignSelected, signActsByClient]);

  const onSignClick = useCallback(() => {
    let signActs = true;
    dataSource.selectList.forEach((el) => {
      if (el.docStatus !== 2) {
        signActs = false;
      }
    });
    if (signActs) {
      setVisiblePopupSignSelected(true);
    } else {
      modalErrorOpen({
        message: `${formatMessage('textModal').textActStatus}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [dataSource.selectList, modalErrorOpen, setVisiblePopupSignSelected]);

  const toolbarButtonEditAct = useMemo(() => () => (
    <Button
      text={dataSource.selectList.length && dataSource.selectList.length === 1
        ? formatMessage('textButton').edit
        : formatMessage('administrationTabs').buttons.sign}
      icon={dataSource.selectList.length && dataSource.selectList.length > 1
        ? 'edit' : ''}
      type={'default'}
      stylingMode={'contained'}
      onClick={dataSource.selectList.length && dataSource.selectList.length === 1
        ? openUpdateActModal
        : onSignClick}
      disabled={!dataSource.selectList.length}
    />
  ), [dataSource.selectList.length, openUpdateActModal, onSignClick]);

  const toolbarButtonDeleteAct = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').remove}
      type={'danger'}
      stylingMode={'contained'}
      onClick={openDeleteActModal}
      disabled={!dataSource.selectList.length || dataSource.selectList.length > 1}
    />
  ), [dataSource.selectList.length, openDeleteActModal]);

  const toolbarButtonAddPiece = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').add}
      type={'default'}
      stylingMode={'contained'}
      onClick={openUpdateAddPiece}
      disabled={!dataSourcePiece.selectList.length || (dataSource.selectList.length > 1)}
    />
  ), [dataSource.selectList.length, dataSourcePiece.selectList.length, openUpdateAddPiece]);

  const toolbarButtonDeletePiece = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').remove}
      type={'danger'}
      stylingMode={'contained'}
      onClick={openUpdateDeletePiece}
      disabled={!dataSourcePiece.selectList.length || (dataSource.selectList.length > 1)}
    />
  ), [dataSource.selectList.length, dataSourcePiece.selectList.length, openUpdateDeletePiece]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid({
        filter: value
      });
    }
  }, []);

  const dataGridOnOptionChangedPiece = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGridPiece({
        filter: value
      });
    }
  }, []);

  const actsTable = useMemo(
    () => (
      <DataGridMVP dataSource={actsByStock}
                   keyExpr="docNumId"
                   className="shipment"
                   setDataGridInstance={setActsGridInstance}
                   setStateStoringName={'dataGridActData'}
                   onSelectionChanged={onSelectionChanged}
                   filterDataGrid={filterDataGrid}
                   setFilterDataGrid={setFilterDataGrid}
                   dataGridOnOptionChanged={dataGridOnOptionChanged}
                   showBorders
                   visibleButtonDateRangePicker={false}
                   visibleInfoIcon={false}
                   visibleSummary={false}
                   visibleGroupPanel={false}
                   visibleButtonAddResponsiblePerson
                   visibleButtonPersonVisit
                   isDataLoading={actLoading}
                   // focusedRowEnabled
      >
        {columnDataGridAct.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonEditAct} />
        <Template name="toolbarButtonVisitResponsiblePerson" render={toolbarButtonDeleteAct} />
      </DataGridMVP>
    ),
    [
      actLoading,
      actsByStock,
      dataGridOnOptionChanged,
      filterDataGrid,
      onSelectionChanged,
      toolbarButtonDeleteAct,
      toolbarButtonEditAct
    ]
  );

  const piecesTable = useMemo(
    () => (
      <DataGridMVP dataSource={piecesByAct}
                   keyExpr="pieceNumId"
                   className="shipment"
                   setStateStoringName={'dataGridPiecesData'}
                   onSelectionChanged={onSelectionChangedPiece}
                   filterDataGrid={filterDataGridPiece}
                   setFilterDataGrid={setFilterDataGridPiece}
                   dataGridOnOptionChanged={dataGridOnOptionChangedPiece}
                   showBorders
                   visibleButtonDateRangePicker={false}
                   visibleInfoIcon={false}
                   visibleSummary={false}
                   visibleGroupPanel={false}
                   visibleButtonAddResponsiblePerson={actData.docStatus !== 4}
                   visibleButtonPersonVisit
                   isDataLoading={pieceLoading}
      >
        {columnDataGridPiece.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonAddPiece} />
        <Template name="toolbarButtonVisitResponsiblePerson" render={toolbarButtonDeletePiece} />
      </DataGridMVP>
    ),
    [
      piecesByAct,
      onSelectionChangedPiece,
      filterDataGridPiece,
      dataGridOnOptionChangedPiece,
      pieceLoading,
      toolbarButtonAddPiece,
      toolbarButtonDeletePiece,
      actData
    ]
  );

  const renderModalActUpdate = useMemo(() => (
    <PopupMVP
      visible={modalsVisible.modalActUpdate}
      onHiding={onHidingModals}
      title={formatMessage('textTabListEditAct')}
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textTableAdminActs').docId}</span>
            <TextBox
              value={actData && actData.docId}
              onValueChanged={({ value }) =>
                setActData({
                  ...actData,
                  docId: value
                })}
              stylingMode="outlined"
            />
          </div>
          <div className="optionsData">
            <span>{formatMessage('textTableAdminActs').docDate}</span>
            <DateBox
              type="date"
              displayFormat="dd.MM.yyyy"
              value={actData && actData.docDate}
              onValueChanged={({ value }) =>
                setActData({
                  ...actData,
                  docDate: normalizeDateToSend(value)
                })}
              width="100%"
              stylingMode="outlined"
              openOnFieldClick
              useMaskBehavior
            />
          </div>
        </div>
        <div className="formButton">
          <Button
            text={formatMessage('textButton').cancel}
            type="default"
            stylingMode="text"
            onClick={onHidingModals}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={260}
            onClick={handleUpdateAct}
          >
            <LoadIndicator
              className="indicator"
              visible={actUpdate.loading}
            />
            <span>{formatMessage('textButton').save}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    actData,
    actUpdate.loading,
    modalsVisible.modalActUpdate,
    onHidingModals,
    handleUpdateAct
  ]);

  const renderModalActDelete = useMemo(() => (
    <PopupMVP
      visible={modalsVisible.modalActDelete}
      onHiding={onHidingModals}
      title={formatMessage('textModal').deleteAct}
    >
      <div className="formData">
        {`${formatMessage('textModal').textDeleteAct} № ${actData.docId} ?`}
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={onHidingModals}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            onClick={handleDeleteAct}
          >
            <LoadIndicator
              className="indicator"
              visible={actDelete.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    modalsVisible.modalActDelete,
    onHidingModals,
    actData.docId,
    handleDeleteAct,
    actDelete.loading
  ]);

  const renderModalAddPiece = useMemo(() => (
    <PopupMVP visible={modalsVisible.modalAddPiece}
              onHiding={onHidingModals}
              title={formatMessage('textModal').addPiece}
    >
      <div className="formData">
        <div className="optionsData">
          <span>{formatMessage('textModal').listPiece}</span>
          <SelectBox stylingMode="outlined"
                     items={[
                       ...new Map(
                         piecesByStock.map((item) => [
                           item.pieceNumId,
                           item
                         ])
                       ).values()
                     ].map((el) => ({
                       key: `${el.qcId}/${el.cgId}/${el.actualPieceId}`,
                       value: el.pieceNumId
                     }))}
                     value={pieceData}
                     valueExpr={'value'}
                     displayExpr={'key'}
                     searchEnabled
                     onValueChanged={({ value }) => setPieceData(value)}
          />
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModals}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={handleAddPiece}
                  width={200}
                  disabled={!pieceData}
          >
            <LoadIndicator className="indicator" visible={addPiece.loading} />
            <span>{formatMessage('textButton').addReady}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    addPiece.loading,
    handleAddPiece,
    modalsVisible.modalAddPiece,
    onHidingModals,
    pieceData,
    piecesByStock
  ]);

  const renderModalPieceDelete = useMemo(() => (
    <PopupMVP
      visible={modalsVisible.modalDeletePiece}
      onHiding={onHidingModals}
      title={formatMessage('textModal').deletePiece}
    >
      <div className="formData">
        {`${formatMessage('textModal').youSure}?`}
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={onHidingModals}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            onClick={handleDeletePiece}
          >
            <LoadIndicator
              className="indicator"
              visible={deletePiece.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    modalsVisible.modalDeletePiece,
    onHidingModals,
    handleDeletePiece,
    deletePiece.loading
  ]);

  const RenderSignActs = useCallback(() => (
    <PopupMVP
      visible={visiblePopupSignSelected}
      onHiding={onSignPopupHiding}
      title="Подписать"
    >
      <div className="formData">
        <span>
          {`${formatMessage('textModal').signActsByClient} № ${visiblePopupSignSelected
            && !!docNumIds.length
            ? docNumIds.join(', ') : selectedDocIds.join(', ')}?`}
        </span>
        <div className="formButton">
          <Button
            text={formatMessage('textButton').cancel}
            type="danger"
            stylingMode="text"
            onClick={onSignPopupHiding}
          />
          <Button
            type="default"
            stylingMode="contained"
            text={formatMessage('textButton').confirm}
            width={200}
            onClick={onSignConfirmClick}
          />
        </div>
      </div>
    </PopupMVP>
  ), [visiblePopupSignSelected, onSignPopupHiding, docNumIds, selectedDocIds, onSignConfirmClick]);
  return (
    <>
      <SplitterLayout>
        <div className={styles.topSide}>
          {actsTable}
        </div>
        <div className={styles.bottomSide}>
          {piecesTable}
        </div>
      </SplitterLayout>
      {renderModalActUpdate}
      {renderModalActDelete}
      {renderModalAddPiece}
      {renderModalPieceDelete}
      <RenderSignActs />
    </>
  );
};

export default React.memo(EditAct);
